import React from "react"
import styled from "styled-components"
import { ReactComponent as InfiniteSVG } from "./svg/infinite.svg"

export default function Input({
  value,
  handler,
  onBlur,
  infinite,
  maxLength,
  onFocus,
}: any) {
  return (
    <>
      <InputSt
        value={value}
        onChange={handler}
        onBlur={onBlur}
        onFocus={onFocus}
        maxLength={maxLength}
      />
      {infinite && value === "" && <InfiniteSVG className="infinite" />}
    </>
  )
}

const InputSt = styled.input`
  background: transparent;
  text-align: center;
  border: none;
  color: #ffbb00;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding: 0px 10px;
`
